var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-row',{attrs:{"gutter":10,"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{attrs:{"xs":20,"sm":18,"md":14,"lg":10,"xl":10}},[_c('el-col',{staticClass:"a"},[_c('Connect')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }